export const getDiffColor = (value: number | null) => {
  if (!value) return '#4F5458';
  if (value === 0) return '#4F5458';
  return Math.sign(value) > 0 ? '#00E676' : '#FF1744';
};
